import { setupValidation } from '../utils/component-lib.esm22.js';
const CONFIGURATION = {
  apiBaseUrl: 'https://app.campsite.bio/api',
  env: 'production',
  assetCdn: 'https://cdn.campsite.bio',
  assetsBucketName: 'campsite-bio-storage',
  recaptchaProfilesSiteKey: '6Ld4aT8kAAAAAGCmzvBgA4fMIdmBk4bKmG_yxhAs',
  recaptchaSiteKeyChallenge: '6LeSPF4UAAAAALd9EGLQ5hp9CMRe1CKyBf3XBe1K',
  get isProduction() {
    return this.env === 'production';
  },
  get isStaging() {
    return this.env === 'staging';
  },
  get isDevelopment() {
    return this.env === 'development';
  }
};

/**
 * Setup the component library for use
 * @param {Object} settings
 */
function setupComponentLibrary() {
  let settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Update the configuration
  Object.keys(settings).forEach(key => CONFIGURATION[key] = settings[key]);
  setupValidation();
}
export { CONFIGURATION, setupComponentLibrary };